import { render, staticRenderFns } from "./DriverTopic.vue?vue&type=template&id=4d142e10&"
import script from "./DriverTopic.vue?vue&type=script&lang=js&"
export * from "./DriverTopic.vue?vue&type=script&lang=js&"
import style0 from "./DriverTopic.vue?vue&type=style&index=0&id=4d142e10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports